import { camposInstituicaoProcesso } from "../../../processos/identificacaoInstitucional";
import CabecalhoPaginaSecundaria, { BotaoVoltar } from "../../../componentes/comuns/CabecalhoPaginaSecundaria";
import React, { useEffect, useState, useRef } from "react";
import { keyframes } from "@emotion/react";

import {
  Alert,
  Chip,
  InputAdornment,
  TextField,
  Container,
  Typography,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  LinearProgress,
  CircularProgress,
  Slide,
} from "@mui/material";

import { useParams, useNavigate, useLocation } from "react-router-dom";

import { styled } from "@mui/material/styles";
import DocumentStatus from "../../../componentes/DocumentStatus";
import DevolutivasDocumentoDialog from "./DevolutivasDocumentoDialog";
import AnalistaResponsavel from "../../../componentes/comuns/AnalistaResponsavel";


import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";

import { api, fetchDocumentoPdf } from "@api/api";
import TransicaoPagina from "../../../componentes/comuns/TransicaoPagina";
import { coresTextosGlobais, tamanhosControlesGlobais, tamanhosPaginasAdministrativas } from "../../../estilos/global";

const StyledPaper = styled(Paper)(() => ({
  width: "100%",
  padding: 0,
  borderRadius: 0,
  backgroundColor: "transparent",
  boxShadow: "none",
  display: "flex",
  flexDirection: "column",
  flex: "1 1 auto",
  minHeight: 0,
}));

const formatSeiNumber = (seiNumber) => {
  if (!seiNumber) return "";

  const cleaned = String(seiNumber).replace(/\D/g, "");
  let formatted = "";

  if (cleaned.length > 0) formatted += cleaned.substring(0, 4);
  if (cleaned.length > 4) formatted += "." + cleaned.substring(4, 6);
  if (cleaned.length > 6) formatted += "." + cleaned.substring(6, 13);
  if (cleaned.length > 13) formatted += "/" + cleaned.substring(13, 17);
  if (cleaned.length > 17) formatted += "-" + cleaned.substring(17, 19);

  return formatted;
};

const formatarDataSemFuso = (dataString) => {
  if (!dataString) return "Não informado";

  const [ano, mes, dia] = String(dataString).slice(0, 10).split("-");

  return `${dia}/${mes}/${ano}`;
};

const normalizarTexto = (valor = "") =>
  String(valor)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const SITUACOES_DOCUMENTOS = {
  aprovados: {
    rotulo: "Aprovados",
    cor: "var(--sear-sucesso-texto, #188566)",
    fundo: "var(--sear-sucesso-fundo, #eef8f3)",
    borda: "var(--sear-sucesso-borda, #add7c5)",
    corresponde: (document) => document.aprovacao === true,
  },
  correcao: {
    rotulo: "Correção solicitada",
    cor: "var(--sear-erro-texto, #c55050)",
    fundo: "var(--sear-erro-fundo, #fff1f1)",
    borda: "var(--sear-erro-borda, #edbbbb)",
    corresponde: (document) => document.alteracao_ativa === true,
  },
  analise: {
    rotulo: "Em análise",
    cor: "var(--sear-aviso-texto, #a8760a)",
    fundo: "var(--sear-aviso-fundo, #fff9e9)",
    borda: "var(--sear-aviso-borda, #e5d197)",
    corresponde: (document) =>
      document.aprovacao === false && document.alteracao_ativa === false,
  },
};

const piscarDocumento = keyframes`
  0%, 100% {
    background-color: var(--sear-superficie-azul, #eef7ff);
    box-shadow: 0 0 0 0 rgba(23, 111, 178, 0.15);
  }
  50% {
    background-color: var(--sear-superficie-azul, #d2e9fc);
    box-shadow: 0 0 0 5px rgba(23, 111, 178, 0.3);
  }
`;

const DetalhesProcesso = () => {
  const { processId } = useParams();
  const navigate = useNavigate();
  const { pathname, search, key: chaveNavegacao } = useLocation();

  const documentoNotificado = new URLSearchParams(search).get("documento");
  const situacaoSelecionada = new URLSearchParams(search).get("situacao");
  const destaqueSelecionado = Object.prototype.hasOwnProperty.call(
    SITUACOES_DOCUMENTOS,
    situacaoSelecionada,
  )
    ? SITUACOES_DOCUMENTOS[situacaoSelecionada]
    : null;

  const [detalhes, setDetalhes] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [buscaDocumento, setBuscaDocumento] = useState("");
  const [fileStates, setFileStates] = useState({});

  const inputFileRefs = useRef([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [documentToView, setDocumentToView] = useState(null);
  const [documentUrl, setDocumentUrl] = useState("");
  const [documentError, setDocumentError] = useState("");
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const [openHistorico, setOpenHistorico] = useState(false);
  const [historicoDevolucoes, setHistoricoDevolucoes] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [erroHistorico, setErroHistorico] = useState("");
  const [documentoHistorico, setDocumentoHistorico] = useState(null);
  const [erroAnexoHistorico, setErroAnexoHistorico] = useState("");
  const historicoControllerRef = useRef(null);

  useEffect(() => () => historicoControllerRef.current?.abort(), []);

  const [documentosVisualizados, setDocumentosVisualizados] = useState(
    () => new Set(),
  );

  useEffect(() => {
    setBuscaDocumento("");
    setDocumentosVisualizados(new Set());
  }, [processId, documentoNotificado, chaveNavegacao]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem("token");

        const [processResponse, documentsResponse] = await Promise.all([
          fetch(api.getProcess(processId), {
            method: "GET",
            signal: controller.signal,
            headers: {
              Authorization: token ? `Bearer ${token}` : "",
              "Content-Type": "application/json",
            },
            credentials: "include",
          }),
          fetch(api.getProcessDocs(processId), {
            method: "GET",
            signal: controller.signal,
            headers: {
              Authorization: token ? `Bearer ${token}` : "",
              "Content-Type": "application/json",
            },
            credentials: "include",
          }),
        ]);

        if (!processResponse.ok) {
          throw new Error("Erro ao buscar detalhes do processo");
        }

        if (!documentsResponse.ok) {
          throw new Error("Erro ao buscar documentos do processo");
        }

        const [processData, documentsData] = await Promise.all([
          processResponse.json(),
          documentsResponse.json(),
        ]);

        if (!Array.isArray(documentsData)) {
          throw new Error("Resposta inválida ao buscar documentos do processo");
        }

        if (controller.signal.aborted) return;

        setDetalhes(processData);
        setDocuments(documentsData);
        setFileStates(
          documentsData.map(() => ({
            uploaded: false,
          })),
        );
      } catch (err) {
        if (!controller.signal.aborted) {
          setError(err.message);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => controller.abort();
  }, [processId, refreshKey, chaveNavegacao]);

  const handleFileChange = async (index, event) => {
    const file = event.target.files[0];

    if (!file) return;

    if (file.type !== "application/pdf") {
      alert("Apenas arquivos PDF são permitidos!");

      if (inputFileRefs.current[index]) {
        inputFileRefs.current[index].value = "";
      }

      return;
    }

    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("file", file);

      const response = await fetch(api.updateDoc(documents[index].id), {
        method: "PATCH",
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: formData,
        credentials: "include",
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));

        throw new Error(errorData.message || "Erro ao atualizar documento");
      }

      setRefreshKey((prevKey) => prevKey + 1);

      if (inputFileRefs.current[index]) {
        inputFileRefs.current[index].value = "";
      }
    } catch (err) {
      console.error("Erro no upload:", err);
      alert(err.message || "Erro ao atualizar documento");
    }
  };

  const handleOpenHistorico = async (document) => {
    historicoControllerRef.current?.abort();
    const controller = new AbortController();
    historicoControllerRef.current = controller;
    setDocumentoHistorico(document);
    setHistoricoDevolucoes([]);
    setErroHistorico("");
    setErroAnexoHistorico("");
    setLoadingHistorico(true);
    setOpenHistorico(true);

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(api.userDocumentHistory(document.id), {
        method: "GET",
        signal: controller.signal,
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("Erro ao carregar o histórico do documento");
      }

      const data = await response.json();
      if (controller.signal.aborted) return;
      if (!Array.isArray(data)) {
        throw new Error("Resposta inválida ao carregar o histórico de retornos");
      }

      setHistoricoDevolucoes(data);
      setDocumentosVisualizados((anteriores) =>
        new Set(anteriores).add(String(document.id)),
      );
    } catch (error) {
      if (!controller.signal.aborted) {
        setErroHistorico("Não foi possível carregar o histórico do documento.");
      }
    } finally {
      if (!controller.signal.aborted) setLoadingHistorico(false);
    }
  };

  const handleCloseHistorico = () => {
    historicoControllerRef.current?.abort();
    historicoControllerRef.current = null;
    setOpenHistorico(false);
    setHistoricoDevolucoes([]);
    setLoadingHistorico(false);
    setErroHistorico("");
    setErroAnexoHistorico("");
    setDocumentoHistorico(null);
  };

  const handleBaixarAnexo = async (registro) => {
    if (!registro?.possui_anexo) {
      return;
    }

    setErroAnexoHistorico("");
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(api.userHistoryAttachment(registro.id), {
        method: "GET",
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
        credentials: "include",
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Erro ao baixar o anexo");
      }

      const arquivoBlob = await response.blob();
      const urlTemporaria = URL.createObjectURL(arquivoBlob);

      const link = document.createElement("a");
      link.href = urlTemporaria;
      link.download = registro.anexo_nome || "anexo";

      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(urlTemporaria);
    } catch (error) {
      console.error("Erro ao baixar anexo:", error);
      setErroAnexoHistorico("Não foi possível baixar o anexo. Tente novamente.");
    }
  };

  const handleClick = (index) => {
    if (!inputFileRefs.current[index]) {
      const inputElement = document.createElement("input");

      inputElement.type = "file";
      inputElement.style.display = "none";
      inputElement.accept = "application/pdf";

      inputElement.onchange = (event) => handleFileChange(index, event);

      document.body.appendChild(inputElement);
      inputFileRefs.current[index] = inputElement;
    }

    inputFileRefs.current[index].click();
  };

  const handleOpenDocument = (document) => {
    setDocumentosVisualizados((anteriores) =>
      new Set(anteriores).add(String(document.id)),
    );

    setDocumentToView(document);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDocumentToView(null);
  };

  useEffect(() => {
    if (!openDialog || !documentToView?.id) {
      setDocumentUrl("");
      setDocumentError("");
      setLoadingDocument(false);
      return undefined;
    }

    const controller = new AbortController();
    let objectUrl = "";

    const carregarDocumento = async () => {
      setLoadingDocument(true);
      setDocumentError("");
      setDocumentUrl("");

      try {
        const blob = await fetchDocumentoPdf(
          api.getDocumentoConteudo(documentToView.id),
          {
            signal: controller.signal,
          },
        );

        objectUrl = URL.createObjectURL(blob);
        setDocumentUrl(objectUrl);
      } catch (error) {
        if (error.name !== "AbortError") {
          setDocumentError(error.message);
          setDocumentUrl("");
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoadingDocument(false);
        }
      }
    };

    carregarDocumento();

    return () => {
      controller.abort();

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [openDialog, documentToView]);

  const removerDestaqueSituacao = () => {
    const parametros = new URLSearchParams(search);
    parametros.delete("situacao");
    navigate(
      { pathname, search: parametros.toString() ? `?${parametros}` : "" },
      { replace: true },
    );
  };

  const quantidadeDestacada = destaqueSelecionado
    ? documents.filter(destaqueSelecionado.corresponde).length
    : 0;

  const documentosFiltrados = documents
    .map((document, indexOriginal) => ({
      document,
      indexOriginal,
      destacado: String(document.id) === documentoNotificado,
      destacadoPorSituacao: Boolean(destaqueSelecionado?.corresponde(document)),
    }))
    .filter(({ document }) =>
      normalizarTexto(document.nome_documento).includes(
        normalizarTexto(buscaDocumento),
      ),
    )
    .sort(
      (a, b) =>
        documents.some((doc) => doc.ordem_explicita === true) ? 0 :
        Number(b.destacado) - Number(a.destacado) ||
        Number(b.destacadoPorSituacao) - Number(a.destacadoPorSituacao),
    );

  if (loading) {
    return (
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          mt: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 400, textAlign: "center" }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Carregando detalhes do processo...
          </Typography>

          <LinearProgress color="primary" />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <TransicaoPagina variante="navegacao">
        <Container maxWidth={false} disableGutters sx={{ mt: 3 }}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h5" color="error" sx={{ mb: 2 }}>
              Erro: {error}
            </Typography>

            <BotaoVoltar onClick={() => navigate(-1)} />
          </Box>
        </Container>
      </TransicaoPagina>
    );
  }

  if (!detalhes) {
    return (
      <TransicaoPagina variante="navegacao">
        <Container maxWidth={false} disableGutters sx={{ mt: 3 }}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h5" color="error" sx={{ mb: 2 }}>
              Detalhes do processo não encontrados.
            </Typography>

            <BotaoVoltar onClick={() => navigate(-1)} />
          </Box>
        </Container>
      </TransicaoPagina>
    );
  }

  return (
    <TransicaoPagina variante="navegacao" data-pagina-rolavel="">
      <Container maxWidth={false} disableGutters sx={{ mt: 0, mb: 0, display: "flex", flexDirection: "column", flex: { md: "1 1 0" }, minHeight: 0 }}>
        <StyledPaper elevation={0}>
          <CabecalhoPaginaSecundaria
            titulo="Detalhes do processo"
            descricao="Acompanhe os documentos e as pendências deste processo."
            rotuloVoltar="Voltar aos processos"
            sx={{ flexShrink: 0, "& h1": { color: coresTextosGlobais.tituloPagina }, "& h1 + p": { color: "var(--sear-texto-secundario, #6882a3)" } }}
            onVoltar={() => navigate(-1)}
          />
          <Paper
            component="section"
            aria-label="Dados do processo"
            variant="outlined"
            sx={{ p: 1.5, mb: 1.5, border: "1px solid var(--sear-borda, #d8e9fb)", borderRadius: "10px", background: "linear-gradient(110deg, var(--sear-superficie-azul, #f0f7ff) 0%, var(--sear-superficie, #fbfdff) 80%)", boxShadow: "none", flexShrink: 0 }}
          >
            <Typography component="h2" sx={{ color: coresTextosGlobais.tituloSecao, fontSize: tamanhosPaginasAdministrativas.tituloSecao, fontWeight: 600, overflowWrap: "anywhere" }}>
              {detalhes.processtype}
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))", lg: "minmax(220px, 1.4fr) minmax(100px, .75fr) minmax(110px, .65fr) minmax(180px, 1fr) minmax(140px, .9fr)" }, gap: 1.5, mt: 1 }}>
              {[
                ...camposInstituicaoProcesso(detalhes).map((campo) => ({ ...campo, Icone: SchoolRoundedIcon })),
                { rotulo: "Município", valor: detalhes.state || "Não informado", Icone: LocationOnOutlinedIcon },
                { rotulo: "Data de início", valor: formatarDataSemFuso(detalhes.startdate), Icone: CalendarMonthOutlinedIcon },
                { rotulo: "Analista responsável", valor: detalhes.analista_nome?.trim() || (detalhes.id_analista ? "Nome não disponível" : "Não atribuído"), Icone: PersonOutlineRoundedIcon },
                { rotulo: "Nº SEI", valor: formatSeiNumber(detalhes.seinumber) || "Não informado", Icone: DescriptionOutlinedIcon },
              ].map(({ rotulo, valor, Icone }) => (
                <Box key={rotulo} sx={{ display: "flex", alignItems: "center", gap: 0.8, minWidth: 0 }}>
                  <Icone sx={{ color: "var(--sear-azul, #087cf0)", bgcolor: "var(--sear-superficie-azul, #e1efff)", borderRadius: "50%", p: "6px", width: 18, height: 18, fontSize: 18, boxSizing: "content-box", flexShrink: 0 }} />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography component="span" sx={{ display: "block", color: "var(--sear-texto-secundario, #6983a4)", fontSize: tamanhosControlesGlobais.rotulo }}>{rotulo}</Typography>
                    {rotulo === "Analista responsável" ? (
                      <AnalistaResponsavel id={detalhes.id_analista} nome={detalhes.analista_nome} email={detalhes.analista_email} />
                    ) : (
                      <Typography sx={{ color: coresTextosGlobais.conteudoTabela, fontSize: tamanhosPaginasAdministrativas.conteudoTabela, lineHeight: 1.4, overflowWrap: "anywhere" }}>{valor}</Typography>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          </Paper>

          <Paper
            variant="outlined"
            sx={{ display: "flex", flexDirection: "column", flex: { md: "1 1 0" }, minHeight: 0, border: "1px solid var(--sear-borda, #d4e5f7)", borderRadius: "10px", bgcolor: "var(--sear-superficie, #fff)", boxShadow: "none", overflow: "hidden" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                gap: 1.5,
                px: 1.5,
                py: 1.25,
                bgcolor: "var(--sear-superficie-azul, #f5faff)",
                borderBottom: "1px solid var(--sear-borda, #d5e6f7)",
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography
                  component="h2"
                  sx={{ color: coresTextosGlobais.tituloSecao, fontWeight: 600, fontSize: tamanhosPaginasAdministrativas.tituloSecao }}
                >
                  Documentos do processo
                </Typography>

                <Chip
                  label={documents.length}
                  size="small"
                  sx={{
                    color: "var(--sear-azul, #0767d8)",
                    backgroundColor: "var(--sear-superficie-azul, #e5f1ff)",
                    fontWeight: 700,
                    height: 21,
                    fontSize: tamanhosControlesGlobais.contador,
                  }}
                />
              </Box>

              <TextField
                value={buscaDocumento}
                onChange={(event) => setBuscaDocumento(event.target.value)}
                placeholder="Pesquisar documento..."
                inputProps={{ "aria-label": "Pesquisar documento" }}
                size="small"
                sx={{
                  width: { xs: "100%", sm: 220 },
                  maxWidth: "100%",
                  minWidth: 0,
                  "& .MuiOutlinedInput-root": {
                    minHeight: 34,
                    borderRadius: 1,
                    bgcolor: "var(--sear-superficie, #fff)",
                    fontSize: tamanhosControlesGlobais.campoBusca,
                    "& input": { py: 0.8, color: "var(--sear-azul, #315d92)" },
                    "& fieldset": { borderColor: "var(--sear-borda, #c9def4)" },
                    "&:hover fieldset": { borderColor: "var(--sear-borda-forte, #087cf0)" },
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--sear-borda-forte, #087cf0)",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchRoundedIcon sx={{ color: "var(--sear-azul, #087cf0)", fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {destaqueSelecionado && (
              <Box
                role="status"
                aria-label="Destaque dos documentos"
                sx={{
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 1,
                  px: 2,
                  py: 1,
                  bgcolor: destaqueSelecionado.fundo,
                  borderTop: `1px solid ${destaqueSelecionado.borda}`,
                  borderBottom: `1px solid ${destaqueSelecionado.borda}`,
                }}
              >
                <Typography
                  sx={{
                    fontSize: tamanhosControlesGlobais.descricao,
                    color: destaqueSelecionado.cor,
                  }}
                >
                  <strong>{destaqueSelecionado.rotulo} em destaque</strong>
                  {" · "}{quantidadeDestacada} de {documents.length} documentos
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={removerDestaqueSituacao}
                  sx={{
                    color: destaqueSelecionado.cor,
                    borderColor: destaqueSelecionado.borda,
                    fontSize: tamanhosControlesGlobais.botao,
                    borderRadius: "6px",
                    minHeight: 30,
                    textTransform: "none",
                    px: 1.5,
                  }}
                >
                  Remover destaque
                </Button>
              </Box>
            )}
            <TableContainer data-rolagem-conteudo="" sx={{ overflowX: { xs: "visible", sm: "auto" }, flex: { md: "1 1 0" }, minHeight: 0 }}>
              <Table
                size="small"
                aria-label="Documentos do processo"
                sx={{
                  tableLayout: "fixed",
                  minWidth: { xs: 0, sm: 640 },
                  display: { xs: "block", sm: "table" },
                  "& thead": { display: { xs: "none", sm: "table-header-group" } },
                  "& colgroup": { display: { xs: "none", sm: "table-column-group" } },
                  "& col:nth-of-type(1)": { width: { sm: "33%", lg: "auto" } },
                  "& col:nth-of-type(2)": { width: { sm: "24%", lg: 180 } },
                  "& col:nth-of-type(3)": { width: { sm: "31%", lg: 340 } },
                  "& col:nth-of-type(4)": { width: { sm: "12%", lg: 120 } },
                  "& tbody": { display: { xs: "block", sm: "table-row-group" } },
                  "& tbody > tr": {
                    display: { xs: "grid", sm: "table-row" },
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: { xs: "10px 6px", sm: 0 },
                    p: { xs: 1.5, sm: 0 },
                    borderBottom: { xs: "1px solid var(--sear-borda, #e2edf9)", sm: 0 },
                  },
                  "& th": {
                    color: coresTextosGlobais.cabecalhoTabela,
                    bgcolor: "var(--sear-superficie-azul, #f0f7ff)",
                    fontWeight: 600,
                    fontSize: tamanhosPaginasAdministrativas.cabecalhoTabela,
                    py: 0.7,
                    px: 1.4,
                    borderBottom: "1px solid var(--sear-borda, #d5e6f7)",
                    textAlign: "center",
                  },
                  "& th:first-of-type": { textAlign: "left", pl: 1.4 },
                  "& th:not(:first-of-type)": {
                    borderLeft: { xs: 0, sm: "1px solid var(--sear-borda, #e3edf8)" },
                  },
                  "& td": {
                    fontSize: tamanhosPaginasAdministrativas.conteudoTabela,
                    color: coresTextosGlobais.conteudoTabela,
                    display: { xs: "block", sm: "table-cell" },
                    minWidth: 0,
                    py: { xs: 0, sm: 0.5 },
                    px: { xs: 0, sm: 1.4 },
                    textAlign: "center",
                    verticalAlign: "middle",
                    borderBottomWidth: { xs: 0, sm: 1 },
                    borderColor: "var(--sear-borda, #e2edf9)",
                    overflowWrap: "anywhere",
                  },
                  "& td:first-of-type": {
                    fontWeight: 400,
                    textAlign: "left",
                    pl: { xs: 0, sm: 1.4 },
                    gridColumn: "1 / -1",
                  },
                  "& td:nth-of-type(2)": {
                    textAlign: { xs: "left", sm: "center" },
                    gridColumn: "1 / -1",
                  },
                  "& td:nth-of-type(2) > span": {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    maxWidth: "100%",
                    verticalAlign: "middle",
                    borderRadius: "999px",
                    padding: "4px 9px",
                    whiteSpace: "nowrap",
                    lineHeight: 1.4,
                    fontSize: tamanhosControlesGlobais.rotulo,
                  },
                  "& td[data-rotulo='Ações']": { gridColumn: "1 / span 2" },
                  "& .acoes-documento": {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    alignItems: "center",
                    gap: 1,
                    "& > *": { justifySelf: "center" },
                  },
                  "& td[data-rotulo]::before": {
                    content: "attr(data-rotulo)",
                    display: { xs: "block", sm: "none" },
                    mb: 0.6,
                    fontSize: tamanhosControlesGlobais.rotulo,
                    color: "var(--sear-texto-secundario, #6983a4)",
                  },
                  "& .sem-devolutivas": {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: 30,
                    color: "var(--sear-texto-secundario, #6983a4)",
                  },
                  "& .MuiButton-root": {
                    width: "auto",
                    maxWidth: "100%",
                    fontSize: tamanhosControlesGlobais.botao,
                    borderRadius: "4px",
                    minHeight: 30,
                    minWidth: 0,
                    py: 0.3,
                    px: 0.5,
                    justifyContent: "center",
                    fontWeight: 400,
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                    bgcolor: "transparent",
                    color: "var(--sear-azul, #0875df)",
                    border: 0,
                    textTransform: "none",
                    boxShadow: "none",
                    "&:hover": { bgcolor: "transparent", textDecoration: "underline", transform: "none", boxShadow: "none" },
                    "&.Mui-disabled": { bgcolor: "transparent", color: "var(--sear-texto-secundario, #7d8fa5)", textDecoration: "none" },
                    "& .MuiButton-startIcon": { ml: 0, mr: "4px" },
                    "& .MuiButton-startIcon > *:nth-of-type(1)": { fontSize: 16 },
                    "&.Mui-disabled .MuiButton-startIcon > *:nth-of-type(1)": { fontSize: 13 },
                    "&.Mui-focusVisible": { outline: "2px solid var(--sear-borda-forte, #087cf0)", outlineOffset: 2 },
                  },
                  "@media (pointer: coarse)": {
                    "& .MuiButton-root": { minHeight: 44 },
                  },
                  "@media (max-width: 359px)": {
                    "& .acoes-documento .Mui-disabled .MuiButton-startIcon": { display: "none" },
                  },
                }}
              >
                <colgroup>
                  <col />
                  <col />
                  <col />
                  <col />
                </colgroup>
                <TableHead>
                  <TableRow>
                    {["Documento", "Status", "Ações", "Arquivo"].map((rotulo) => (
                      <TableCell key={rotulo} scope="col">{rotulo}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {documentosFiltrados.length > 0 ? (
                    documentosFiltrados.map(
                      ({ document, indexOriginal, destacado, destacadoPorSituacao }) => (
                        <TableRow
                          key={`${document.id}-${refreshKey}`}
                          hover
                          sx={{
                            bgcolor: destacado ? "var(--sear-superficie-azul, #eef7ff)" : undefined,
                            "&:nth-of-type(odd)": {
                              bgcolor: destacado ? "var(--sear-superficie-azul, #eef7ff)" : "var(--sear-superficie, #fff)",
                            },
                            "&:nth-of-type(even)": { bgcolor: destacado ? "var(--sear-superficie-azul, #eef7ff)" : "var(--sear-superficie-azul, #f7fbff)" },
                            outline: destacado
                              ? "2px solid var(--sear-borda-forte, #176fb2)"
                              : undefined,
                            outlineOffset: "-2px",
                            animation:
                              destacado &&
                              !documentosVisualizados.has(String(document.id))
                                ? `${piscarDocumento} 1.4s ease-in-out infinite`
                                : "none",
                            transition: "background-color 0.3s ease",
                            ...(destacadoPorSituacao && !destacado && {
                              bgcolor: destaqueSelecionado.fundo,
                              "&:nth-of-type(odd), &:nth-of-type(even)": {
                                bgcolor: destaqueSelecionado.fundo,
                              },
                              outline: `1px solid ${destaqueSelecionado.borda}`,
                              outlineOffset: "-1px",
                              animation: "none",
                              "& > td:first-of-type": {
                                borderLeft: `3px solid ${destaqueSelecionado.cor}`,
                                fontWeight: 400,
                              },
                            }),
                            "@media (prefers-reduced-motion: reduce)": {
                              animation: "none",
                            },
                          }}
                        >
                          <TableCell>
                            {destacado && (
                              <Typography
                                variant="caption"
                                sx={{
                                  display: "block",
                                  color: "var(--sear-azul, #176fb2)",
                                  fontWeight: 700,
                                }}
                              >
                                Documento devolvido para correção
                              </Typography>
                            )}

                            {document.nome_documento}
                          </TableCell>

                          <TableCell>
                            <DocumentStatus
                              aprovacao={document.aprovacao}
                              alteracao_ativa={document.alteracao_ativa}
                            />
                          </TableCell>

                          <TableCell data-rotulo="Ações">
                            <Box className="acoes-documento" role="group" aria-label={`Ações: ${document.nome_documento}`}>
                            {document.aprovacao === true && document.alteracao_ativa === false ? (
                                <Box
                                  component="span"
                                  aria-label={`Envio concluído: ${document.nome_documento}`}
                                  sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, minHeight: 30, color: "var(--sear-sucesso-texto, #128465)", fontSize: tamanhosControlesGlobais.botao, whiteSpace: "nowrap" }}
                                >
                                  <CheckRoundedIcon sx={{ fontSize: 16 }} />
                                  Concluído
                                </Box>
                              ) : document.alteracao_ativa === false ? (
                                <Button
                                  startIcon={<LockOutlinedIcon />}
                                  variant="text"
                                  disabled
                                  aria-label={`Envio bloqueado: ${document.nome_documento}`}
                                >
                                  Bloqueado
                                </Button>
                              ) : (
                                <Button
                                  startIcon={<FileUploadOutlinedIcon />}
                                  variant="text"
                                  aria-label={`Enviar: ${document.nome_documento}`}
                                  color={fileStates[indexOriginal]?.uploaded ? "secondary" : "primary"}
                                  onClick={() => handleClick(indexOriginal)}
                                  disabled={fileStates[indexOriginal]?.uploaded || !document.alteracao_ativa}
                                >
                                  {fileStates[indexOriginal]?.uploaded ? "Enviado ✓" : "Enviar"}
                                </Button>
                              )}
                            {/* O histórico continua disponível após o reenvio do documento. */}
                            {document.possui_historico || document.observacao ? (
                              <Button
                                startIcon={<ChatBubbleOutlineRoundedIcon />}
                                variant="text"
                                aria-label={`Consultar histórico do documento: ${document.nome_documento}`}
                                onClick={() => handleOpenHistorico(document)}
                              >
                                Histórico
                              </Button>
                            ) : (
                              <Box component="span" className="sem-devolutivas" aria-label="Sem histórico do documento">—</Box>
                            )}
                            </Box>
                          </TableCell>

                          <TableCell data-rotulo="Arquivo">
                            <Button
                              startIcon={<VisibilityOutlinedIcon />}
                              variant="text"
                              aria-label={`Visualizar: ${document.nome_documento}`}
                              onClick={() => handleOpenDocument(document)}
                            >
                              Ver
                            </Button>
                          </TableCell>
                        </TableRow>
                      ),
                    )
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} sx={{ gridColumn: "1 / -1", textAlign: "center !important" }}>
                        <Typography variant="body2" color="text.secondary">
                          Nenhum documento encontrado para a pesquisa.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </StyledPaper>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="lg"
          fullWidth
          TransitionComponent={Slide}
          transitionDuration={400}
          sx={{
            "& .MuiDialog-paper": {
              height: "90vh",
              maxHeight: "90vh",
              borderRadius: "12px",
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            sx={{
              bgcolor: "var(--sear-acao-azul, #1976d2)",
              color: "common.white",
              fontWeight: "bold",
            }}
          >
            Visualizar Documento
          </DialogTitle>

          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              padding: 0,
              overflow: "hidden",
            }}
          >
            {loadingDocument ? (
              <CircularProgress />
            ) : documentError ? (
              <Alert severity="error">{documentError}</Alert>
            ) : documentUrl ? (
              <iframe
                src={documentUrl}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                title="Documento Visualizado"
              />
            ) : null}
          </DialogContent>

          <DialogActions sx={{ bgcolor: "background.default" }}>
            <Button
              onClick={handleCloseDialog}
              color="primary"
              variant="contained"
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Fechar
            </Button>
          </DialogActions>
        </Dialog>

        <DevolutivasDocumentoDialog
          open={openHistorico}
          documento={documentoHistorico}
          registros={historicoDevolucoes}
          carregando={loadingHistorico}
          erro={erroHistorico}
          erroAnexo={erroAnexoHistorico}
          onClose={handleCloseHistorico}
          onRetry={() => handleOpenHistorico(documentoHistorico)}
          onBaixarAnexo={handleBaixarAnexo}
        />
      </Container>
    </TransicaoPagina>
  );
};

export default DetalhesProcesso;
